import { render, staticRenderFns } from "./OutdatedContractSelect.vue?vue&type=template&id=0a2f45a5&"
import script from "./OutdatedContractSelect.vue?vue&type=script&lang=js&"
export * from "./OutdatedContractSelect.vue?vue&type=script&lang=js&"
import style0 from "./OutdatedContractSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports